/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Success_ConfirmInputs */



/**
* | output |
* | --- |
* | "Ok" |
*
* @param {Iconik_Publish_Success_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_success_confirm = /** @type {((inputs?: Iconik_Publish_Success_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Success_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ok")
	if (locale === "de") return /** @type {LocalizedString} */ ("OK")
	if (locale === "it") return /** @type {LocalizedString} */ ("OK")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Хорошо")
	if (locale === "es") return /** @type {LocalizedString} */ ("De acuerdo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("好的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("わかりました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ठीक है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("OK")
	return /** @type {LocalizedString} */ ("Ok")
});